/**
 * Types for iHerb posts feature
 */

export type PostStatus =
  | 'queued'
  | 'scraping'
  | 'generating'
  | 'refining'
  | 'pending'
  | 'approved'
  | 'rejected'
  | 'sent';

export const IN_PROGRESS_STATUSES: PostStatus[] = ['queued', 'scraping', 'generating', 'refining'];

export interface IherbPost {
  id: string;
  product_id: string;
  product_url: string;
  image_url: string | null;
  price: string | null;
  message: string | null;
  status: PostStatus;
  feedback: string | null;
  sent_at: string | null;
  created_at: string;
  updated_at: string;
  short_url: string | null;
  click_count: number;
}

export interface IherbPostPage {
  items: IherbPost[];
  next_cursor: string | null;
}

export interface GenerateRequest {
  count: number;
}

export interface PostUpdate {
  status?: 'approved' | 'rejected';
  feedback?: string;
}
